import React from 'react'
import Footer from '../Components/Footer'
import Navbar from '../Components/Navbar'
import Testimonials from '../Components/Testimonial'


const Testimonial = () => {
    return (
        <>
            <Navbar/>
            <Testimonials/>
            <Footer/>

            
        </>
    )
}

export default Testimonial;
